// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `Difficulty`.
const Difficulty = __t.enum("Difficulty", {Beginner: __t.unit(),
  Intermediate: __t.unit(),
  Expert: __t.unit(),
  Custom: __t.unit(),
});

export default Difficulty;


